// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NewNetTrader } from '@front/controls/screen/NewNetTrader';
import { WorkSpaceManager } from '@front/controls/WorkSpace/WorkSpaceManager';
import { DockSystem } from '@front/controls/DockSystem';
import { MainWindowManager } from '@front/controls/UtilsClasses/MainWindowManager';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import WebTraderTemplate from '@front/templates/WebTraderTemplate.html';
import { DataCache } from './DataCache';
import { Connection, ConnectionInstanceCreator } from './Connection';
import { ApplicationLoader } from './ApplicationLoader';
import { CreateApplicationInfo } from './CreateApplicationInfo';
import { ApplicationHandlersInitializer } from './ApplicationHandlersInitializer';
import { TradingToolViewBase } from '@front/chart/Tools/TradingTools/TradingToolViewBase';
let fromUnload = null;
class Application {
    constructor() {
        this.Templates = {};
        this.mainWindow = null;
    }
    // TODO. Refactor. Ugly.
    Initialize() {
        CreateApplicationInfo();
        this.InitializeDivConstants();
        ApplicationHandlersInitializer.Initialize();
        ThemeManager.subscribeOnImagesLoaded(TradingToolViewBase.ThemeChanged);
        ThemeManager.themeChange();
        const self = this;
        this.InitializeWebtrader().then(function () {
            ConnectionInstanceCreator(DataCache, () => {
                Application.disconnectPortfolioSelfCalledTab();
            });
            self.InitMainWindowAndContextMenu();
            MainWindowManager.MainWindow.Controls.loginScreen.localize();
            DockSystem.InitSystem('dockMainContainer');
        });
    }
    InitializeDivConstants() {
        const resStr = WebTraderTemplate;
        document.body.innerHTML += resStr;
    }
    InitStorages(skip = false) {
        if (!skip) {
            ConnectionInstanceCreator(DataCache, () => {
                Application.disconnectPortfolioSelfCalledTab();
            });
        }
    }
    // TODO. Refactor.
    InitializeWebtrader() {
        this.InitStorages(true);
        fromUnload = null; // при событии закрытия вкладки с приложением перед дисконнектом этот флажок становится true
        MainWindowManager.portfolioWindow = null; // тут лежит ссылка на окно портфолио, если такое было вызвано с основного приложения
        window.onbeforeunload = function (e) {
            if (window.preventUnload) {
                window.preventUnload = false;
                return;
            }
            if (MainWindowManager.IsWorkMode) {
                void WorkSpaceManager.synchronizeWorkspacesBeforeExit();
            }
        };
        window.onunload = function () {
            fromUnload = true; // doc. 3.1).3  https://docs.google.com/document/d/1Tnb1LqXehcolTHU2ZEOywAuHLcYOXWA3Grsjddu0C-E/edit#heading=h.9o7dj749n3zi
            if (Connection.disconnect) {
                Connection.disconnect();
            }
        };
        return ApplicationLoader();
    }
    InitMainWindowAndContextMenu() {
        new NewNetTrader();
        document.addEventListener('contextmenu', function (e) {
            e.preventDefault();
        });
    }
    static disconnectPortfolioSelfCalledTab() {
        // закрытие вкладки с портфолио если она была вызвана при данном коннекшне doc. 3.1)  https://docs.google.com/document/d/1Tnb1LqXehcolTHU2ZEOywAuHLcYOXWA3Grsjddu0C-E/edit#heading=h.9o7dj749n3zi
        if (MainWindowManager.portfolioWindow && !fromUnload) {
            MainWindowManager.portfolioWindow.close();
            MainWindowManager.portfolioWindow = null;
        }
        fromUnload = null;
    }
}
export const App = new Application();
